import { render } from "./ModeratorSelect.vue?vue&type=template&id=30fdc492"
import script from "./ModeratorSelect.vue?vue&type=script&lang=ts"
export * from "./ModeratorSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script